var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-awards bg-red"},[_c('div',{staticClass:"page__inner"},[_c('k-block',{attrs:{"name":"ad_banner_1"}}),_c('k-block',{attrs:{"name":"awards_2_body"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }